import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import * as React from "react";
import { CountryBase } from "../../templates/fragments/country";
import { Region } from "../../templates/fragments/region";
import { DestinationMonthPicker } from "./month-picker";

import { useMonth } from "../../hooks/useMonth";
import { City } from "../../templates/fragments/city";
import { Resort } from "../../templates/fragments/resort";
import { Breadcrumbs as SharedBreadcrumbs } from "../shared/breadcrumbs";
import { Breadcrumbs } from "./breadcrumbs";

export const DestinationPageHero = ({
    bgImage,
    header,
    resort = null,
    region = null,
    country = null,
    continent = null,
    city = null,
    doNotShowMonthPicker = false,
    doNotShowBreadcrumbs = false,
    small = false,
    className = ""
}: {
    bgImage?: ImageDataLike;
    header: string;
    resort?: Resort;
    region?: Region;
    country?: CountryBase;
    continent?: string;
    city?: City;
    doNotShowMonthPicker?: boolean;
    doNotShowBreadcrumbs?: boolean;
    small?: boolean;
    className?: string;
}) => {
    const { month } = useMonth({});
    let links;
    if (city) {
        links = [
            { path: "/", text: "Home" },
            {
                path: city.continent
                    ? `/${city.continent}/${city.country}-weather-${month}`
                    : undefined,
                text: city.countryName
            },
            {
                path: `/cities/${city.pathSlug}-weather-climate`,
                text: city.name
            }
        ];
    }
    return (
        <div className={`${className} relative w-full`}>
            {bgImage ? (
                <GatsbyImage
                    alt=""
                    image={getImage(bgImage)}
                    className={`${
                        small
                            ? "h-[260px]"
                            : "h-[300px] md:h-[350px] xl:h-[420px]"
                    }`}
                />
            ) : (
                <div className="h-[240px] bg-sh-red-dark md:h-[255px] xl:h-[270px]"></div>
            )}
            {/* Mask */}
            <div className="absolute top-0 h-full w-full bg-black/30"></div>

            {!doNotShowBreadcrumbs &&
                (city ? (
                    <SharedBreadcrumbs links={links} />
                ) : (
                    <Breadcrumbs
                        resort={resort}
                        region={region}
                        country={country}
                        continent={continent}
                    ></Breadcrumbs>
                ))}
            
            <h1 className={`pointer-events-none absolute ${small ? "top-0 bottom-0" : "top-[20px] bottom-[50px]"} grid w-full items-center px-[24px] text-center text-[30px] font-bold leading-[1.3em] tracking-wide text-white xm:px-12 xm:text-[36px] sm:text-4xl md:px-40`}>
                {header}
            </h1>
            {!doNotShowMonthPicker && (
                <>
                    <DestinationMonthPicker
                        omitLinks={(resort && resort.isSingle) || !!city}
                        defaultWidth={1600}
                        className="mdmax:hidden"
                    />
                    <DestinationMonthPicker
                        omitLinks={(resort && resort.isSingle) || !!city}
                        defaultWidth={400}
                        className="md:hidden"
                    />
                </>
            )}
        </div>
    );
};
